export default {
  en: 'English',
  ru: 'Русский'
};